import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugStatins} from "./TextDrugStatins"


export default function Statin() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
 
    <ButtonsText onClick={handleOpen} name='Statin' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Statin - PGx Recommendation"
        content={ <TextDrugStatins />}

        />

</>
)}